import { toJpeg } from 'html-to-image';
import { jsPDF }  from 'jspdf';

// Exporta um elemento da tela como JPEG ou PDF, do jeito que ele está sendo exibido
// (linhas recolhidas, filtros etc.). Durante a captura a classe "is-exporting"
// desliga rolagens e colunas fixas (ver main.css) para a tabela sair inteira.
// Elementos com data-export-ignore (botões, engrenagens) ficam de fora.
const PDF_MARGIN  = 24;
const PDF_TITLE_H = 30;

const _nextFrame = () => new Promise(resolve => requestAnimationFrame(() => resolve()));

export async function exportElement(node, { format, fileName, title }) {

    node.classList.add('is-exporting');

    try {

        await _nextFrame();

        const width  = node.scrollWidth;
        const height = node.scrollHeight;

        const dataUrl = await toJpeg(node, {
            quality:         0.95,
            pixelRatio:      2,
            backgroundColor: '#ffffff',
            width,
            height,
            filter: (element) => !(element.dataset && 'exportIgnore' in element.dataset),
        });

        if (format === 'jpeg') {

            const link = document.createElement('a');
            link.href     = dataUrl;
            link.download = `${fileName}.jpeg`;
            link.click();
            return;
        }

        // A página do PDF tem o tamanho da tabela (em pt), mais margem e título.
        const pageW = width  + PDF_MARGIN * 2;
        const pageH = height + PDF_MARGIN * 2 + (title ? PDF_TITLE_H : 0);

        const pdf = new jsPDF({ orientation: pageW > pageH ? 'landscape' : 'portrait', unit: 'pt', format: [pageW, pageH] });

        if (title) {
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(14);
            pdf.setTextColor(0, 42, 104);
            pdf.text(title, PDF_MARGIN, PDF_MARGIN + 12);
        }

        pdf.addImage(dataUrl, 'JPEG', PDF_MARGIN, PDF_MARGIN + (title ? PDF_TITLE_H : 0), width, height);
        pdf.save(`${fileName}.pdf`);

    } finally {

        node.classList.remove('is-exporting');
    }
}
